<template>
  <div class="invoice invoice-ar">
    <div class="row">
      <div class="col-8">
        <div class="main-text">
          <div class="text-logo">
            <p>{{ pills.book_number }}</p>
            <h4>فاتورة ضريبية</h4>
          </div>
          <div class="next-text">
            <h4>تأكيد حجز الفنادق</h4>
            <h5>
              حالة الحجز: <span>{{ $t(book_status_name) }}</span>
            </h5>
            <h6 v-if="pills.created_at_date">
              تاريخ الحجز:
              {{ pills.created_at_date }} -
              {{ pills.created_at_time }}
            </h6>
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="logo">
          <img :src="pills.organization?.default_image" />
        </div>
      </div>
    </div>

    <div class="table_account" v-if="pills?.account">
      <div class="list_account">
        <div class="account_data">
          <p class="title_account">العميل</p>
          <p class="text_account">: {{ pills.client_name }}</p>
        </div>
        <div class="account_data">
          <p class="title_account">اسم النزيل</p>
          <p class="text_account">: {{ pills.guest_name }}</p>
        </div>
        <div class="account_data">
          <p class="title_account">الجنسية</p>
          <p class="text_account">: {{ pills.nationality_name }}</p>
        </div>
      </div>
      <div class="list_account">
        <div class="account_data">
          <p class="title_account">تاريخ الدخول</p>
          <p class="text_account">
            : {{ pills.check_in_date }},
            {{ updateHijriDate(new Date(pills.check_in_date)) }}
          </p>
        </div>
        <div class="account_data">
          <p class="title_account">تاريخ الخروج</p>
          <p class="text_account">
            : {{ pills.check_out_date }},
            {{ updateHijriDate(new Date(pills.check_out_date)) }}
          </p>
        </div>
      </div>
      <div class="list_account">
        <div
          class="account_data"
          v-for="(hotel, index) in pills.hotels"
          :key="index"
        >
          <p class="title_account">اسم الفندق {{ index + 1 }}</p>
          <p class="text_account hotel_name">: {{ hotel.hotel_name }}</p>
        </div>
      </div>
    </div>

    <!-- room table -->
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th class="frist">القندق</th>
            <th class="frist">نوع الغرفة</th>
            <th scope="col">الوجبة</th>
            <th scope="col">عدد الأشخاص</th>
            <th scope="col">تاريخ الدخول</th>
            <th scope="col">تاريخ الخروج</th>
            <th scope="col">الليالي</th>
            <th scope="col">رقم التأكيد</th>
            <th scope="col">سعر الليلة</th>
            <th class="last">السعر الكلي</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(room, index) in pills.rooms" :key="index">
            <td>{{ room.hotel_name }}</td>
            <td>
              <p class="mb-0 fs-8">
                {{ room.room_number }} X {{ room.room_name }}
              </p>
              <p class="mb-0 fs-8">{{ room.title_view }}</p>
            </td>
            <td>{{ room.meal_type?.title }}</td>
            <td>{{ room.guest_number }}</td>
            <td>
              <p class="mb-0">
                {{ room.check_in_date }}
              </p>
              <span class="hijri">{{
                updateHijriDate(new Date(room.check_in_date))
              }}</span>
            </td>
            <td>
              <P class="mb-0">
                {{ room.check_out_date }}
              </P>
              <span class="hijri">{{
                updateHijriDate(new Date(room.check_out_date))
              }}</span>
            </td>
            <td>{{ room.number_of_nights }}</td>
            <td>{{ room.hotel_reference }}</td>
            <td>
              {{
                (
                  room.total_selling_price_room_without_tax /
                  room.number_of_nights
                ).toFixed(2)
              }}
            </td>
            <td class="last">
              {{ room.total_selling_price_room_without_tax }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- room table -->

    <services :service="service" v-if="service.length" />

    <TotalPrice
      :total_selling_price_with_out_tax="total_selling_price_with_out_tax"
      :selling_tax="selling_tax"
      :total_selling_price="total_selling_price"
    />

    <!-- <div class="qr">
      <img src="@/assets/media/image/qr-code.png" />
    </div> -->
    <div class="end-page">
      <div class="hed terms" v-if="pills?.Conditions">
        <h4>الشروط والاحكام</h4>
        <p class="text" v-html="pills?.Conditions?.description"></p>
      </div>
      <div class="hed terms" v-if="pills?.book_notes">
        <h4>الملاحظات</h4>
        <p class="text" v-html="pills?.book_notes"></p>
      </div>
    </div>
    <div class="lastes">
      <h4>{{ pills.organization?.name }}</h4>
      <div class="d-flex align-items">
        <h4 v-if="pills.organization?.phone" class="mx-2">
          الهاتف:
          <span
            ><a :href="`tel:${pills.organization?.phone}`">{{
              pills.organization?.phone
            }}</a></span
          >
        </h4>
        <h4 v-if="pills.organization?.email" class="mx-2">
          الأيميل:
          <span
            ><a :href="`mailto:${pills.organization?.email}`">{{
              pills.organization?.email
            }}</a></span
          >
        </h4>
        <h4 v-if="pills.organization?.address">
          العنوان:
          {{ pills.organization?.address }}
        </h4>
      </div>
    </div>
  </div>
</template>

<script>
import services from "./component/servicesAR.vue";
import TotalPrice from "./component/TotalPriceAr.vue";

export default {
  name: "pill-hotel-tax",
  data() {
    return {
      lang: "ar",
    };
  },
  props: {
    pills: Object,
    service: {
      type: Array,
      required: true,
      default: () => [],
    },
    terms: String,
    total_selling_price_with_out_tax: String,
    selling_tax: String,
    total_selling_price: String,
    book_status_name: String,
  },
  components: {
    services,
    TotalPrice,
  },
};
</script>

<style lang="scss" scoped>
@import "./_pill.scss";
</style>
